
/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
  let regPos = /^\d+(\.\d+)?$/
  if (regPos.test(value)) {
    // 如果是数字
    let getDate = new Date(value)
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      S: getDate.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return fmt
  } else {
    // TODO
    value = value.trim()
    return value.substr(0, fmt.length)
  }
}

/**
* 检测图片是否存在
* @param url
*/
export function imageIsExist(url) {
  return new Promise((resolve) => {
    var img = new Image()
    img.onload = function () {
      if (this.complete == true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

/**
 * @param {*} fn 要执行的函数
 * @param {*} interval 时间间隔
 * @returns
 */
export function throttle(fn, interval = 200) {
  // 1.记录上一次的开始时间
  let lastTime = 0

  // 2.事件触发时, 真正执行的函数
  const _throttle = function () {
    // 2.1.获取当前事件触发时的时间
    const nowTime = new Date().getTime()

    // 2.2.使用当前触发的时间和之前的时间间隔以及上一次开始的时间, 计算出还剩余多长时间需要去触发函数
    const remainTime = interval - (nowTime - lastTime)
    // 第一次会执行，原因是nowTime刚开始是一个很大的数字，结果为负数
    // 若最后一次没能满足条件，不会执行
    if (remainTime <= 0) {
      // 2.3.真正触发函数
      fn()
      // 2.4.保留上次触发的时间
      lastTime = nowTime
    }
  }

  return _throttle
}

/**
* 判断是什么文件
* @param url 文件地址
*/
export function checkFileType(url) {
  if (!url || typeof url !== 'string') {
    return 'other'
  }

  // 清理 URL：移除查询参数和哈希，提取文件名
  const cleanUrl = url.split('?')[0].split('#')[0].trim()
  const fileName = cleanUrl.split('/').pop() // 获取文件名部分
  const extension = fileName.toLowerCase().split('.').pop()

  // 文档类型映射
  const typeMap = {
    // Word 文档
    doc: 'doc',
    docx: 'doc',
    docm: 'doc',
    dot: 'doc',
    dotx: 'doc',
    // PDF 文件
    pdf: 'pdf',
    // text 文件
    txt: 'txt',
    // 图片文件
    jpg: 'jpg',
    png: 'jpg',
    // 压缩包文件
    zip: 'zip',
    rar: 'zip',
    // Excel 文件
    xls: 'excel',
    xlsx: 'excel',
    xlsm: 'excel',
    xlsb: 'excel',
    csv: 'excel', // CSV 也可视为 Excel 相关
    xlt: 'excel',
    xltx: 'excel'
  }

  return typeMap[extension] || 'other'
}



// WEBPACK FOOTER //
// ./src/utils/util.js